export { default as CooperativeFilled } from './cooperative-filled.vue'
